export default "./dist/stdassets/images/icons/invoke-url.png";